import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressBookDto, BankDto, IndividualAcreagesDto, LandTitleDto, LessorAreaMakerDto, LessorInfoDto, LessorRepresentativeDto, LessorRepTypeDto, LessorStakeholderDto, MeasureDto, OwnershipTypeDto, TerrainDto } from '@cradua/data';

@Component({
  selector: 'cradua-lessor-main-view',
  templateUrl: './lessor-main-view.component.html',
  styleUrls: ['./lessor-main-view.component.scss']
})
export class LessorMainViewComponent implements OnInit {

  @Input() selectedLessorInfo: LessorInfoDto;
  @Input() lessorRepTypes: LessorRepTypeDto[];
  @Input() terrains: TerrainDto[];
  @Input() measures: MeasureDto[];
  @Input() banks: BankDto[];
  @Input() lessorAreaMakers: LessorAreaMakerDto[];
  @Input() ownershipTypes: OwnershipTypeDto[];
  @Input() lessorRepresentatives: LessorRepresentativeDto[];
  @Input() lessorStakeholders: LessorStakeholderDto[];
  @Input() individualAcreages: IndividualAcreagesDto[];
  @Input() isLoadingLessorRepresentative: boolean;
  @Input() isLoadingLessorStakeholder: boolean;
  @Input() isLoadingIndividualAcreages: boolean;
  @Input() isLoadingLessorAreaMaker: boolean;
  @Input() addressBooks: AddressBookDto[];
  @Input() selectedLandTitle: LandTitleDto;
  @Output() emitLessorAreaMaker = new EventEmitter<any>();
  @Output() emitLessorRepresentative = new EventEmitter<any>();
  @Output() emitLessorStakeholder = new EventEmitter<any>();
  @Output() emitIndividualAcreages = new EventEmitter<any>();

  @Output() emitLessorAreaMakerDelete = new EventEmitter<any>();
  @Output() emitLessorRepresentativeDelete = new EventEmitter<any>();
  @Output() emitLessorStakeholderDelete = new EventEmitter<any>();
  @Output() emitIndividualAcreagesDelete = new EventEmitter<any>();
  @Output() emitTask = new EventEmitter<any>();
  assignedArea = 0;

  selectedLessor: any;
  tab = 'surveyArea'

  constructor() { }

  ngOnInit(): void {
    if(this.individualAcreages != null && this.individualAcreages.length) {
      const foundAcreages = this.individualAcreages
      .map((item) => item.NetArea);

      this.assignedArea =  foundAcreages.length ? foundAcreages
      .reduce((prev, next) => prev + next) : 0;
    }
    this.selectedLessor = {
      addressBook: this.getAddressBook(this.selectedLessorInfo.AddressBookId),
      ...this.selectedLessorInfo
    }
  }

  onSurvey() {
    this.tab = 'surveyArea';
  }

  onLessorAcreage() {
    this.tab = 'lessorAcreage'
  }

  onLessorRep() {
    this.tab = 'lessorRepresentative'
  }

  onLessorStakeholder() {
    this.tab = 'stakeholder'
  }

  getAddressBook(id: string) {
    const foundAddressBook = this.addressBooks.find(item => item.id === id);
   return foundAddressBook ? foundAddressBook : {};
  }

  getOwnershipTypeName(id: string) {
    const found = this.ownershipTypes.find(own => own.id === id);
    return found ? found.OwnershipTypeName : '';
  }

  onBack() {
    this.emitTask.emit('list');
  }

  onEmitBack(value) {
    this.emitTask.emit('list');
  }
  onEmitLessorAreaMaker(value: LessorAreaMakerDto[]) {
    this.emitLessorAreaMaker.emit(value);
  }
  onEmitLessorRepresentative(value: LessorRepresentativeDto[]) {
    this.emitLessorRepresentative.emit(value);
  }
  onEmitLessorStakeholder(value: LessorStakeholderDto[]) {
    this.emitLessorStakeholder.emit(value);
  }
  onEmitIndividualAcreages(value: IndividualAcreagesDto[]) {
    this.emitIndividualAcreages.emit(value);
  }

  onEmitLessorAreaMakerDelete(value) {
    this.emitLessorAreaMakerDelete.emit(value);
  }
  onEmitLessorStakeholderDelete(value) {
    this.emitLessorStakeholderDelete.emit(value);
  }
  onEmitLessorRepresentativeDelete(value) {
    this.emitLessorRepresentativeDelete.emit(value);
  }
  onEmitIndividualAcreagesDelete(value) {
    this.emitIndividualAcreagesDelete.emit(value);
  }


}
